import React from 'react';
import { Helmet } from "react-helmet";
import { useParams } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { base_url_url } from "../igtComponant/Links";
import { Link } from 'react-router-dom';
import axios from 'axios';

export const WebsiteEnquiry = () => {
    const [formStep, setFormStep] = useState(1);
    const [radioButton, setradioButton] = useState();
    const [data, setData] = useState([]);
    const [formName, setName] = useState();
    const [formEmail, setEmail] = useState();
    const [formAddressPostalCode, setAddressPostalCode] = useState();
    const [formWhatsapp, setWhatsapp] = useState();
    const [formBusninessName, setBusninessName] = useState();
    const [formBusninessEmail, setBusninessEmail] = useState();
    const [formBusninessNumber, setBusninessNumber] = useState();
    const [formWebsiteGoal, setWebsiteGoal] = useState();
    const [formWebsiteService, setWebsiteService] = useState();
    const [formWebsitePages, setWebsitePages] = useState();
    const [formWebsiteRef, setWebsiteRef] = useState();
    const [formWebsiteColor, setWebsiteColor] = useState();
    const [formCurrentDomain, setCurrentDomain] = useState();
    const [formCurrentDomainHost, setCurrentDomainHost] = useState();
    const [formNewHost, setNewHost] = useState();
    const [formOnlineChat, setOnlineChat] = useState();
    const [formAudioVideo, setAudioVideo] = useState();
    const [formSellProduct, setSellProduct] = useState();
    const [formHowManyPages, setHowManyPages] = useState();
    const [formSOcialMedia, setSocialMedia] = useState();
    const [fileData, setFileData] = useState();
   

    /*Error */
    const [emailError, setEmailError] = useState();

    const [loading, setLoading] = useState(false);
    const [formLoading, setFormLoading] = useState(false);

    const form = useRef();
    const [formmessage, setFormMessage] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();
        setFormLoading(true);
        const formData = new FormData();

        formData.append("file-logo", fileData);
    
        formData.append('your-email', formEmail);
        formData.append('your-name', formName);
        formData.append('address-postal-code', formAddressPostalCode);
        formData.append('whatsapp', formWhatsapp);
        formData.append('busniness-name', formBusninessName);
        formData.append('busniness-email', formBusninessEmail);
        formData.append('bussiness-number', formBusninessNumber);
        formData.append('website-goal', formWebsiteGoal);
        formData.append('website-services', formWebsiteService);
        formData.append('website-pages', formWebsitePages);
        formData.append('website-ref-eample', formWebsiteRef);
        formData.append('website-color', formWebsiteColor);
        formData.append('hosting-current-domain', formCurrentDomain);
        formData.append('hosting-current-site-hosted', formCurrentDomainHost);
        formData.append('hosting-need-new-hosting', formNewHost);
        formData.append('hosting-online-chat', formOnlineChat);
        formData.append('audio-video', formAudioVideo);
        formData.append('sell-product', formSellProduct);
        formData.append('how-many-pages', formHowManyPages);
        formData.append('social-media', formSOcialMedia);
         
        fetch('https://www.igtechso.com/IGT-Contact/wp-json/contact-form-7/v1/contact-forms/11/feedback', {
            method: 'POST',
            body: formData,

        }).then(res => res.json()).then(data => {
            clearForm();
            console.log(data);
            setFormLoading(false);
            if (data.status === "mail_sent") {
                setFormMessage('<p className="success">Mail is sent successfully. We will contact you soon.<p>');
            } else {
                setFormMessage('<p className="faild">Mail is sent is failed.<p>');
            }
            setLoading(false);
        }).catch(error => console.log(error));

    };

    const clearForm = () => {
        setName("");
        setEmail("");
        setAddressPostalCode("");
        setWhatsapp("");
        setBusninessName("");
        setBusninessEmail("");
        setBusninessNumber("");
        setWebsiteGoal("");
        setWebsiteService("");
        setWebsitePages("");
        setWebsiteRef("");
        setWebsiteColor("");
        setCurrentDomain("");
        setCurrentDomainHost("");
        setNewHost("");
        setOnlineChat("");
        setAudioVideo("");
        setSellProduct("");
        setHowManyPages(""); 
        setFormStep(1);

        document.querySelector("input#HowManyPages-yes").checked = false;



        setTimeout(() => {
            setFormMessage("");
        }, 10000)
    }

    const fileChangeHandler = (e) => {
        setFileData(e.target.files[0]);
    };

    setTimeout(() => {
        setLoading(true);
    }, 300);


    const formStep_1 = (e) => {
        e.preventDefault();
        setFormStep(2);
    }

    const formStep_2 = (e) => {
        e.preventDefault();
        setFormStep(3);
    }

    const formStep_3 = (e) => {
        e.preventDefault();
        setFormStep(4);
    }

    const formStep_4 = (e) => {
        e.preventDefault();
        setFormStep(5);
    }

    const formStep_5 = (e) => {
        e.preventDefault();
        //setFormStep(6);
        console.log('\n',formNewHost);
    }


    return (
        <>

            <Helmet>
                <base href={process.env.PUBLIC_URL}> </base>
                <title> Website Enquiry | IGTechso Pvt. Ltd. </title>
                <link rel="canonical" href={`${process.env.PUBLIC_URL}/website-enquiry/`}></link>
                <meta name="description" content="IGT" />
                <meta name="keywords" content="IGT" />
                <meta name="author" content="IGT" />
            </Helmet>
            <section className="services-header" id="career">
                <div className="bg">
                    <img src={`${base_url_url}service-bottom-left.png`} alt="Background Layer" title="Background Layer" width="auto" height="auto" className="bottom-left" />
                    <img src={`${base_url_url}service-top-right.png`} alt="Background Layer" title="Background Layer" width="auto" height="auto" className="top-right" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="content-section">
                            <h2>Website Enquiry</h2>
                        </div>
                    </div>
                </div>
            </section>
            <section className='careerInfo'>
                <div className='container'>
                    <div className='careerSingle' style={{ 'paddingTop': '44px' }}>

                        <div className='form'>
                            <div className='stepsForm' form-step-position={formStep}>
                                <div className='steps'>
                                    <p>01</p>
                                    <p>02</p>
                                    <p>03</p>
                                    <p>04</p>
                                    <p>05</p>
                                </div>
                                <div className='stepFormInner'>
                                    <div className={`inputForm`} id="form1">
                                        <form onSubmit={formStep_1} >
                                            <h2>Personal Details</h2>
                                            <p>Thank you for taking the time to answer these questions. The following questions are about to know how well known and successful is Infinity Genesis Techso Private Limited</p>
                                            <div className='three-column'>
                                                <input type="text" value={formName} onChange={(e) => setName(e.target.value)} placeholder="Name" required />
                                                <input type="email" value={formEmail} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                                            </div>
                                            <textarea value={formAddressPostalCode} onChange={(e) => setAddressPostalCode(e.target.value)} placeholder="Address + Postal Code" required /><br />
                                            <input type="number" value={formWhatsapp} onChange={(e) => setWhatsapp(e.target.value)} placeholder="WhatsApp Numbers" required />

                                            <div className='formBottomNavigation'>
                                                <button style={{ "margin-top": "30px" }} type="submit" value="Submit Now" className='submit-btn' >Next</button>

                                            </div>
                                        </form>
                                    </div>

                                    <div className={`inputForm`} id="form2">
                                        <form onSubmit={formStep_2}>
                                            <h2>Business Info</h2>
                                            <input type="text" value={formBusninessName} onChange={(e) => setBusninessName(e.target.value)} placeholder="Name Of Business" required />
                                            <input type="email" value={formBusninessEmail} onChange={(e) => setBusninessEmail(e.target.value)} placeholder="Business Email" required />                                   
                                            <input type="number" value={formBusninessNumber} onChange={(e) => setBusninessNumber(e.target.value)} placeholder="Phone Number" required />
                                            <div className='formBottomNavigation'>
                                                <p onClick={() => setFormStep(1)}>Back</p>
                                                <button style={{ "margin-top": "30px" }} type="submit" value="Submit Now" className='submit-btn' >Next</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className={`inputForm`} id="form3">
                                        <form onSubmit={formStep_3}>
                                        <h2>Basic Details Website Design</h2>
                                        <textarea value={formWebsiteGoal} onChange={(e) => setWebsiteGoal(e.target.value)} placeholder="The primary goal, or mission, the web site needs to achieve is:"  />
                                        <textarea value={formWebsiteService} onChange={(e) => setWebsiteService(e.target.value)} placeholder="List the services that your company provides "  />                                   
                                        <textarea value={formWebsitePages} onChange={(e) => setWebsitePages(e.target.value)} placeholder="Could you please let us know the pages/Tabs you required for the website?"  />                                   
                                        <textarea value={formWebsiteRef} onChange={(e) => setWebsiteRef(e.target.value)} placeholder="Please provide 3 examples of websites you like, and describe why"  />                                   
                                        <label>Do you have a logo? If yes, please attache here</label>
                                        <input type="file" onChange={fileChangeHandler} />
                                        <itextarea value={formSOcialMedia} onChange={(e) => setSocialMedia(e.target.value)} placeholder="What social media channels does your company currently use?"  />                                   
                                        <textarea value={formWebsiteColor} onChange={(e) => setWebsiteColor(e.target.value)} placeholder="Do you have any suggestions on the colors to be used on the website?"      />                                   
                                        <div className='formBottomNavigation'>
                                            <p onClick={() => setFormStep(2)}>Back</p>
                                            <button style={{"margin-top": "30px"}} type="submit" value="Submit Now" className='submit-btn' >Next</button>
                                        </div> 
                                        </form>
                                    </div>

                                    <div className={`inputForm`} id="form4">
                                    <form onSubmit={formStep_4}>
                                        <h2>Domain/Hosting</h2>
                                        <input type="url" value={formCurrentDomain} onChange={(e) => setCurrentDomain(e.target.value)} placeholder="What is your current domain or URL?"  />
                                        <textarea value={formCurrentDomainHost} onChange={(e) => setCurrentDomainHost(e.target.value)} placeholder="Where is your current site hosted?"  />
                                        <div className='formBottomNavigation'>
                                            <p onClick={() => setFormStep(3)}>Back</p>
                                            <button style={{"margin-top": "30px"}} type="submit" value="Submit Now" className='submit-btn' >Next</button>
                                        </div>
                                    </form>
                                    </div>

                                    <div className={`inputForm`} id="form5">
                                        <form onSubmit={sendEmail} >
                                        <h2>Check List</h2>
                                        <div className='radio-button'>
                                            <h3>Do you need a new hosting company?</h3>
                                            <div className='input-radio'>
                                                <input type="radio" name="newHosting" id="newHosting-yes" value={formNewHost} onChange={()=>setNewHost("Yes")} required/><label for="newHosting-yes">Yes</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="newHosting" id="newHosting-no" value={formNewHost} onChange={()=>setNewHost("No")} required /><label for="newHosting-no">No</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="newHosting" id="newHosting-maybe" value={formNewHost} onChange={()=>setNewHost("Maybe")} required/><label for="newHosting-maybe">Maybe</label>
                                            </div>
                                        </div>
                                        
                                        <div className='radio-button'>
                                            <h3>Do you want an online chat feature included on the website?</h3>
                                            <div className='input-radio'>
                                                <input type="radio" name="OnlineChat" id="OnlineChat-yes" onChange={()=>setOnlineChat("Yes")} required/><label for="OnlineChat-yes">Yes</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="OnlineChat" id="OnlineChat-no" onChange={()=>setOnlineChat("No")} required /><label for="OnlineChat-no">No</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="OnlineChat" id="OnlineChat-maybe" onChange={()=>setOnlineChat("Maybe")} required/><label for="OnlineChat-maybe">Maybe</label>
                                            </div>
                                        </div>

                                        <div className='radio-button'>
                                            <h3>Do you want to add video/audio files to the website?</h3>
                                            <div className='input-radio'>
                                                <input type="radio" name="AudioVideo" id="AudioVideo-yes" onChange={()=>setAudioVideo("Yes")} required/><label for="AudioVideo-yes">Yes</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="AudioVideo" id="AudioVideo-no" onChange={()=>setAudioVideo("No")} required /><label for="AudioVideo-no">No</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="AudioVideo" id="AudioVideo-maybe" onChange={()=>setAudioVideo("Maybe")} required/><label for="AudioVideo-maybe">Maybe</label>
                                            </div>
                                        </div>

                                        <div className='radio-button'>
                                            <h3>Will your new website sell products and accept payments?</h3>
                                            <div className='input-radio'>
                                                <input type="radio" name="SellProduct" id="SellProduct-yes" onChange={()=>setSellProduct("Yes")} required/><label for="SellProduct-yes">Yes</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="SellProduct" id="SellProduct-no" onChange={()=>setSellProduct("No")} required /><label for="SellProduct-no">No</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="SellProduct" id="SellProduct-maybe" onChange={()=>setSellProduct("Maybe")} required/><label for="SellProduct-maybe">Maybe</label>
                                            </div>
                                        </div>
                                        
                                        <div className='radio-button'>
                                            <h3>How many pages will your new website be?</h3>
                                            <div className='input-radio'>
                                                <input type="radio" name="HowManyPages" id="HowManyPages-yes" onChange={()=>setHowManyPages("+5")} required/><label for="HowManyPages-yes">+5</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="HowManyPages" id="HowManyPages-no" onChange={()=>setHowManyPages("+10")} required /><label for="HowManyPages-no">+10</label>
                                            </div>
                                            <div className='input-radio'>
                                                <input type="radio" name="HowManyPages" id="HowManyPages-maybe" onChange={()=>setHowManyPages("+20")} required/><label for="HowManyPages-maybe">+20</label>
                                            </div>
                                        </div>

                                        <div className='formBottomNavigation'>
                                            <p onClick={() => setFormStep(4)}>Back</p>
                                            <button style={{ "margin-top": "30px" }} type="submit" value="Submit Now" className='submit-btn' >SUBMIT NOW</button>
                                        </div>
                                        </form>
                                    </div>

                                </div>
                            </div>


                            {
                                formLoading ? <p className='progress'><i className='fa fa-spinner'></i></p> : <p dangerouslySetInnerHTML={{ __html: formmessage }} />
                            }
                        </div>
                    </div>
                </div>
            </section>

        </>

    )
}

export default WebsiteEnquiry;